import {DETERMINAR_PAGINA_ATUAL_RELATORIO_ITINERARIOS} from '../types';

export default function determinarPaginaAtualRelatorioItinerarios(paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_RELATORIO_ITINERARIOS,
    payload: paginaAtual
  };
}
